<template>
    <h5-dialog>
        <template v-slot:header>
            <div class="title text-center m-b">关于防止未成年人沉迷网络游戏的通知</div>
        </template>
        <div>
            <div class="phase">
                <div class="phase-title">各省、自治区、直辖市新闻出版局,各网络游戏企业，有关行业组织：</div>
                <div class="phase-content">
                    近年来，网络游戏行业在满足群众休闲娱乐需要、丰富人民精神文化生活的同时，也出现一些值得高度关注的问题，特别是未成年人沉迷网络游戏、过度消费等现象，对未成年人身心健康和正常学习生活造成不良影响，社会反映强烈。规范网络游戏服务，引导网络游戏企业切实把社会效益放在首位，有效遏制未成年人沉迷网络游戏、过度消费等行为，保护未成年人身心健康成长，是贯彻落实习近平总书记关于青少年工作重要指示精神、促进网络游戏繁荣健康有序发展的有效举措。现就有关工作事项通知如下。
                </div>
            </div>
            <div class="phase">
                <div class="phase-title">一、实行网络游戏用户账号实名注册制度。</div>
                <div class="phase-content">
                    所有网络游戏用户均须使用有效身份信息方可进行游戏账号注册。自本通知施行之日起，网络游戏企业应建立并实施用户实名注册系统，不得以任何形式为未实名注册的新增用户提供游戏服务。自本通知施行之日起2个月内，网络游戏企业须要求已有用户全部完成实名注册，对未完成实名注册的用户停止提供游戏服务。对用户提供的实名注册信息，网络游戏企业必须严格按照有关法律法规妥善保存、保护，不得用作其他用途。
                </div>
            </div>

            <div class="phase">
                <div class="phase-title">二、严格控制未成年人使用网络游戏时段、时长。</div>
                <div class="phase-content">
                    所有网络游戏企业仅可在周五、周六、周日和法定节假日每日20时至21时向未成年人提供1小时服务
                </div>
            </div>

            <div class="phase">
                <div class="phase-title">三、规范向未成年人提供付费服务。</div>
                <div class="phase-content">
                    网络游戏企业须采取有效措施，限制未成年人使用与其民事行为能力不符的付费服务。网络游戏企业不得为未满8周岁的用户提供游戏付费服务。同一网络游戏企业所提供的游戏付费服务，8周岁以上未满16周岁的用户，单次充值金额不得超过50元人民币，每月充值金额累计不得超过200元人民币；16周岁以上未满18周岁的用户，单次充值金额不得超过100元人民币，每月充值金额累计不得超过400元人民币。
                </div>
            </div>
            <div class="phase">
                <div class="phase-title">四、切实加强行业监管。</div>
                <div class="phase-content">
                    本通知前述各项要求，均为网络游戏上网出版运营的必要条件。各地出版管理部门要切实履行属地监管职责，严格按照本通知要求做好属地网络游戏企业及其网络游戏服务的监督管理工作。对未落实本通知要求的网络游戏企业，各地出版管理部门应责令限期改正；情节严重的，依法依规予以处理，直至吊销相关许可。各地出版管理部门协调有关执法机构做好监管执法工作。
                </div>
            </div>
            <div class="phase">
                <div class="phase-title">五、探索实施适龄提示制度。</div>
                <div class="phase-content">
                    网络游戏企业应从游戏内容和功能的心理接受程度、对抗激烈程度、可能引起认知混淆程度、可能导致危险模仿程度、付费消费程度等多维度综合衡量，探索对上网出版运营的网络游戏作出适合不同年龄段用户的提示，并在用户下载、注册、登录页面等位置显著标明。有关行业组织要探索实施适龄提示具体标准规范，督促网络游戏企业落实适龄提示制度。网络游戏企业应注意分析未成年人沉迷的成因，并及时对造成沉迷的游戏内容、功能或者规则进行修改。
                </div>
            </div>
            <div class="phase">
                <div class="phase-title">六、积极引导家长、学校等社会各界力量履行未成年人监护守护责任，加强对未成年人健康合理使用网络游戏的教导，帮助未成年人树立正确的网络游戏消费观念和行为习惯。</div>
                <div class="phase-content">
                    
                </div>
            </div>

            <div class="phase">
                <div class="phase-title">七、本通知所称未成年人是指未满18周岁的公民，所称网络游戏企业含提供网络游戏服务的平台。</div>
                <div class="phase-content">
                
                </div>
            </div>

            <div class="phase">
                本通知自2019年11月1日起施行。
            </div>

            <div class="phase text-right">
                国家新闻出版署
            </div>

            <div class="phase text-right">
                2019年10月25日
            </div>
        </div>
        <template v-slot:footer>
            <button class="btn btn-primary btn-block" @click="handleAgree">确认</button>
        </template>
    </h5-dialog>
</template>

<script>
import H5Dialog from './H5Dialog'

export default {
    name: 'Juveniles',
    components: { H5Dialog },
    methods: {
        handleAgree() {
            this.$emit('agree')
        },
    },
}
</script>

<style scoped>
    .phase {
        font-size: 14px;
        margin-bottom: 12px;
    }

    .phase-title {
        /* font-weight: 600; */
    }

    .phase-content {
        text-indent: 2rem;
        margin-bottom: 8px;
    }

    .phase-content .phase-content {
        text-indent: 1rem;
        padding-left: 1rem;
    }

    .title {
        font-size: 16px;
        font-weight: 600;
        width: 100%;
    }
</style>
